module.exports = __webpack_public_path__ + "img/esg_en.ea67882.png";